import React, { useState } from "react";
import { cards } from "../../constants/__mock__";
import BookItem from "../BookItem/BookItem";
// import component 👇
import Drawer from "react-modern-drawer";
import Carousel from "react-simply-carousel";
import { AntCloudOutlined, UnorderedListOutlined, ClearOutlined } from "@ant-design/icons";
import { Book } from "lucide-react";

//import styles 👇
import "react-modern-drawer/dist/index.css";
function Cards() {
  const [index, setIndex] = useState(0);
  const [drawer, setDrawer] = useState(0);
  const [tagFilter, setTagFilter] = useState("");
  const [seriesFilter, setSeriesFilter] = useState("");
  const openCloud = () => {
    setDrawer(1);
  };
  const openSeries = () => {
    setDrawer(2);
  };
  const openLivros = () => {
    setDrawer(3);
  };
  const openMenu = () => {
    setDrawer(4);
  };
  const clearFilters = () => {
    setTagFilter("");
    setSeriesFilter("");
    setDrawer(0);
    setIndex(0);
  };
  const filteredCards = cards.filter((card) => {
    if (tagFilter !== "" && seriesFilter !== "") {
      return card.tags.includes(tagFilter) && card.serie_name === seriesFilter;
    } else if (tagFilter !== "") {
      return card.tags.includes(tagFilter);
    } else if (seriesFilter !== "") {
      return card.serie_name === seriesFilter;
    } else {
      return true;
    }
  });
  const tagCloud = [];
  cards.forEach((card) => {
    card.tags.forEach((tag) => {
      if (!tagCloud.includes(tag)) {
        tagCloud.push(tag);
      }
    });
  });
  const series = [];
  cards.forEach((card) => {
    if (card.serie_name && !series.find((s) => s.serie_name === card.serie_name)) {
      series.push({ serie_name: card.serie_name, serie_id: card.serie_id });
    }
  });
  tagCloud.sort((a, b) => a.localeCompare(b));
  series.sort((a, b) => a.serie_name.localeCompare(b.serie_name));
  const hasFilters = tagFilter !== "" || seriesFilter !== "";
  const nextIndex = () => {
    setIndex((prev) => (prev < filteredCards.length - 1 ? prev + 1 : 0));
  };
  const prevIndex = () => {
    setIndex((prev) => (prev > 0 ? prev - 1 : filteredCards.length - 1));
  };
  return (
    <>
      <Drawer open={drawer === 4} onClose={() => setDrawer(0)} direction="top" className="drawer" size={90}>
        <div style={{ display: "flex", alignItems: "center", padding: "20px", textAlign: "center", justifyContent: "center" }}>
          <AntCloudOutlined style={{ fontSize: "50px", color: "#ab60e5" }} onClick={openCloud} size={50} />

          <Book size={50} style={{ fontSize: "50px", color: "#ab60e5" }} onClick={openLivros} />

          <UnorderedListOutlined style={{ fontSize: "50px", color: "#ab60e5" }} onClick={openSeries} />
          {hasFilters && <ClearOutlined style={{ fontSize: "50px", color: "#ab60e5" }} onClick={clearFilters} />}
        </div>
      </Drawer>
      <Drawer open={drawer === 1} onClose={() => setDrawer(0)} direction="left" className="drawer">
        <div className="drawer-content">
          <h2 style={{ color: "#ab60e5", textAlign: "center" }}>Tag Cloud</h2>
          <div className="tags">
            <div className="tags-list">
              {tagCloud.map((tag, i) => (
                <div
                  key={i}
                  className={`tag ${tagFilter === tag ? "tags-list--selected" : ""}`}
                  onClick={() => {
                    clearFilters();
                    setTagFilter(tag);
                  }}>
                  {tag}
                </div>
              ))}
            </div>
          </div>
        </div>
      </Drawer>
      <Drawer open={drawer === 2} onClose={() => setDrawer(0)} direction="right" className="drawer">
        <div className="drawer-content">
          <h2 style={{ color: "#ab60e5", textAlign: "center" }}>Sagas</h2>
          <div className="tags">
            <div className="tags-list">
              {series.map((item, i) => (
                <div
                  key={i}
                  className={`tag ${seriesFilter === item.serie_name ? "tags-list--selected" : ""}`}
                  onClick={() => {
                    clearFilters();
                    setSeriesFilter(item.serie_name);
                  }}>
                  {item.serie_name}
                </div>
              ))}
            </div>
          </div>
        </div>
      </Drawer>
      <Drawer open={drawer === 3} onClose={() => setDrawer(0)} direction="bottom" className="drawer" size={160}>
        <Carousel
          containerProps={{
            style: {
              width: "100%",
              justifyContent: "space-between",
              userSelect: "none",
            },
          }}
          swipeTreshold={60}
          activeSlideIndex={index}
          activeSlideProps={{
            style: {
              border: "2px solid blue",
            },
          }}
          onRequestChange={setIndex}
          itemsToShow={10}
          speed={400}
          centerMode>
          {filteredCards?.map((item, index) => (
            <div
              onClick={() => {
                setIndex(index);
                setDrawer(0);
              }}
              style={{
                width: 150,
                height: 150,
                borderRadius: "50%",
                border: "2px solid white",
                textAlign: "center",
                boxSizing: "border-box",
                backgroundImage: `url(${item.thumbnail})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
              key={index}></div>
          ))}
        </Carousel>
      </Drawer>
      <div className="cards-container">
        <div className="cards">
          {filteredCards?.map((card, i) => {
            return index === i ? (
              <BookItem
                key={i}
                card={card}
                hasFilters={hasFilters}
                prevIndex={prevIndex}
                nextIndex={nextIndex}
                onCloudClick={openCloud}
                onSeriesClick={openSeries}
                onLivroClick={openLivros}
                onMenuClick={openMenu}
                clearFilters={clearFilters}
                setSeriesFilter={setSeriesFilter}
                setTagFilter={setTagFilter}
                selectedSeries={seriesFilter}
                selectedTag={tagFilter}
              />
            ) : null;
          })}
        </div>
      </div>
    </>
  );
}

export default Cards;
